<template>
  <modal id="detalhes-tarefa" class="modal-detalhes-tarefa" :titulo="titulo" :loading="loading">
    <template v-if="tarefa">
      <div id="aba-dados-principais" v-if="tarefa">
        <card>
          <div class="row gutters-xs tarefa">
            <v-input class="col-12" :error="validation.titulo" v-model="tarefa.titulo" type="text" label="Título" :required="true" id="titulo"/>
            <v-input type="v-select" :error="validation.tipoServico" :options="listas.tiposServico" label="Tipo de Tarefa" class="col-12" @change="setTipoServico()"  v-model="tarefa.tipoServico" />

            <div class="col-12" v-for="(papel, index) in papeis" :key="papel.capitalize()">
              <v-input class="w-100" :label="papel.capitalize()" :error="validation[papel]" :ref="index" v-if="!tarefa[papel]">
                <template #label>
                  <i class="fal fa-question-circle ml-2 small"></i>
                  <alert-indisponibilidade v-if="tarefa[papel]" class="ml-2" :pessoa="tarefa[papel].indicadorPessoalId" />
                  <alert-pep v-if="tarefa[papel]" class="ml-2" :pessoa="tarefa[papel].indicadorPessoalId" />
                </template>

                <buscar-pessoa :data-testid="papel" @add="selecionar($event, papel)" :novo="true" :key="papel.capitalize()" />
              </v-input>
              <div class="row gutters-xs" v-else>
                <v-input class="col form-group" :label="papel.capitalize()">
                  <input type="text" readonly :value="tarefa[papel].nome + (tarefa[papel].versao ? ' (' + 'Versão: ' + tarefa[papel].versao + ')' : '')" class="form-control form-control-xs" />
                </v-input>

                <div class="col-auto">
                  <button class="btn btn-outline-secondary btn-xs" style="margin-top: 26px" @click="selecionar(null, papel)" type="button" title="Remover">
                    <i class="fal fa-times"></i>
                  </button>
                </div>

                <div class="col-auto">
                  <button class="btn btn-outline-secondary btn-xs" style="margin-top: 26px" @click="envolvido(tarefa[papel], papel)" type="button" title="Editar">
                    <i class="fal fa-edit"></i>
                  </button>
                </div>
              </div>
            </div>

            <v-input class="col-12" type="editor" label="Descrição" :html-editor="false" v-model="tarefa.descricao" />
          </div>
        </card>
      </div>
    </template>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <v-button :run="salvar" class="btn-outline-primary">Salvar</v-button>
    </template>
  </modal>
</template>

<script>

import {defineComponent} from "vue";
import Modal from "@/components/Modal.vue";
import Card from "@/components/Layout/components/Card.vue";
import TipoServicoBusiness from "@/business/crud/TipoServicoBusiness";
import TarefaBusiness from "@/business/tarefa/TarefaBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import Utils from "@/commons/Utils";
import FormIndicadorPessoal from "@/components/IndicadorPessoal/Form/FormIndicadorPessoal.vue";

export default defineComponent({
  components: {AlertIndisponibilidade: () => import("@/components/alert/AlertIndisponibilidade"),
    AlertPep: () => import("@/components/alert/AlertPep"),
    Card, Modal},
  modal:{
    width: 800,
    escapable: false
  },
  props: {
    id: String
  },
  data() {
    return {
      loading: false,
      tarefa : {},
      tipoServico: {},
      validation: {},
      papeis: [],
      listas: {
        tiposServico : []
      }
    }
  },
  async mounted(){
    this.loading = true;
    await TipoServicoBusiness.getByDominioSimples('PERSONALIZADO').then(l => this.listas.tiposServico = l);

    if(this.id){
      this.tarefa = await TarefaBusiness.getById(this.id);
      this.tipoServico = this.tarefa.tipoServico;
    }

    this.tarefa.tipoServico = this.tarefa.tipoServico || null;

    this.loading = false;
  },
  methods: {
    close : FrontBusiness.closeModal,

    selecionar(envolvido, papel, stop) {
      this.$set(this.tarefa, papel, envolvido?.id ? envolvido : null);
      let papeis = this.papeis.filter(t => t != papel);

      if(!stop){
        papeis.forEach(te => {
          if(envolvido?.id && (!this.tarefa?.[te]?.id || envolvido.indicadorPessoal?.id == this.tarefa?.[te]?.indicadorPessoalId)){
            this.selecionar(envolvido, te, true);
          }
        });
      }
    },

    showError(e) {
      FrontBusiness.fullErrorHandler(this, e, '#formulario-tarefa');
    },

    setTipoServico(){
      if(this.tipoServico){
        this.tarefa.tipoServico = this.listas.tiposServico.find(e => e.id == this.tarefa.tipoServico);
        this.papeis = this.tarefa.tipoServico.opcoes.vincularInteressadoSolicitante ? ['interessado', 'solicitante'] : [];
      }
    },

    async envolvido(envolvido, papel) {
      let retorno = await FrontBusiness.openModal(FormIndicadorPessoal, {versaoId: envolvido?.id});
      if (retorno) {
        this.selecionar(retorno, papel);
        this.$refs.alertaErrosTomador[0].load(retorno.id);
      }
    },

    async salvar() {
      let obrigatorios = ['titulo', 'tipoServico'], validated = true;

      obrigatorios.forEach(e => {
        if (Utils.isEmptyNullOrUndefined(this.tarefa[e])) {
          this.$set(this.validation, e, 'Campo obrigatório');
          validated = false;
        }
      });

      if(validated) {
        let dto = Utils.clone(this.tarefa);
        dto.tipoServico = Utils.getObjectId(dto.tipoServico);
        dto.usuario =  Utils.getObjectId(dto.usuario);

        let retorno = await TarefaBusiness.save(dto, this.tarefa?.id).catch(this.showError);
        if(retorno){
          FrontBusiness.redirect(`tarefa/${retorno}/geral`);
          this.close();
        }
      }
    },
  },
  computed:{
    titulo(){
      return this.id ? 'Editar Tarefa' : 'Cadastrar Tarefa';
    }
  },
})
</script>

<style>

</style>
